import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, any } from "keautils";
import { validation, formfields } from "kea-react"
import { RxfyScalar } from "react-rxk";
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Observable } from "rxjs";
import { ContactoClienteList } from "app/features/general/catalogos/items/clientes/edit/componentes/contactos/list";

const GuiasOcupanAutoriz = (props: { folios: string[] }) =>
    <div className="alert alert-warning">
        <label>
            <i className={fa("exclamation", "fw")} />
            Veirifique receptor
        </label>
        <br />
        Las siguientes guias ocupan verificación del receptor:
        <br />
        <span style={{ fontFamily: "monospace" }}>
            {props.folios.join(", ")}
        </span>
    </div>;

const GuiasNoOcupanAutoriz = () =>
    <div className="alert alert-success">
        <label>
            <i className={fa("check", "fw")} />
            No requiere verificar receptor
        </label>
        <br />
        Ninguna guia requiere que se compruebe la identidad del receptor
    </div>;


interface Props {
    guias: models.GuiaDTO[];
    autorizados: models.ContactoCliente[];
}
class ContactosAutorizadosNoRx extends React.PureComponent<Props> {
    guias = (props: Props) => props.guias;
    guiasOcupanAutorizado = createSelectorRx(this.guias, guias => guias.filter(x => x.RequiereContactoAutorizado));
    foliosAutoriz = createSelectorRx(this.guiasOcupanAutorizado, x => x.map(y => y.Folio));

    ocupaAutoriz = createSelectorRx(this.guiasOcupanAutorizado, x => any(x));
    contactos = (props: Props) => this.props.autorizados;

    render() {
        const ocupaAutoriz = this.ocupaAutoriz(this.props);
        const foliosAutoriz = this.foliosAutoriz(this.props);
        const contactos = this.contactos(this.props);
        return (
            <div>
                {ocupaAutoriz ?
                    <div>
                        <GuiasOcupanAutoriz folios={foliosAutoriz} />
                        <ContactoClienteList label="Autorizados a recibir" value={contactos} readonly={true} />
                    </div> :
                    <GuiasNoOcupanAutoriz />
                }
            </div>
        );
    }
}
export const ContactosAutorizadosRx = componentToRx(ContactosAutorizadosNoRx);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/autorizados/view.tsx